'use strict';var renderCell=require('./renderCell');module.exports=function(a){return a.columns.map(renderCell.bind(null,a))};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-menus/lib/MenuItem/renderCells.js
 ** module id = 897
 ** module chunks = 0
 **/